module.exports = __webpack_public_path__ + "img/gaugeDottedBg.d33d66fa.svg";